module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NyIgaGVpZ2h0PSI0NSIgdmlld0JveD0iMCAwIDQ3IDQ1Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjQ3IiBoZWlnaHQ9IjQ1IiBmaWxsPSIjNzlDRTg2IiByeD0iMjIuNSIvPgogICAgICAgIDxnIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjMiPgogICAgICAgICAgICA8cGF0aCBkPSJNMzQuMTE4IDIyLjVIMTIuMTg2TTIzLjUgMTEuODgydjIxLjkzMiIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/group-2.svg
// module id = +ogG
// module chunks = 1